import { useId } from 'react';
import './reasonChips.css';

/**
 * Auswahl genau eines Grundes als Chips (`radiogroup`), für Storno und Preiskorrektur an der Kasse. Mit Pfeiltasten und
 * Tab bedienbar wie eine Gruppe von Optionsfeldern; der Wert wird mit dem Tipp gewählt.
 */
export function ReasonChips<T extends string>({
  label,
  options,
  value,
  onChange,
}: {
  label: string;
  options: readonly { value: T; label: string }[];
  value: T | null;
  onChange: (next: T) => void;
}) {
  const id = useId();
  return (
    <div className="reason" role="group" aria-labelledby={id}>
      <span id={id} className="reason__label">
        {label}
      </span>
      <div className="reason__chips" role="radiogroup" aria-labelledby={id}>
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={value === option.value}
            className="chip reason__chip"
            onClick={() => {
              onChange(option.value);
            }}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
